// extracted by mini-css-extract-plugin
export default {"overlay":"PopupMobileModal_overlay__Z24aK","modal":"PopupMobileModal_modal__Xmii4","slideUp":"PopupMobileModal_slideUp__8K9dF","closeBtn":"PopupMobileModal_closeBtn__ZGuyV"};